import React, { useState } from 'react';
import { useNotify } from '../../context/NotificationContext';

export default function ReferralCard({ userId, directReferrals }) {
  const notify = useNotify();
  const [copied, setCopied] = useState(false);

  const refLink = typeof window !== 'undefined' && userId
    ? `${window.location.origin}/register?ref=${userId}`
    : '';

  function copy() {
    if (!refLink) return;
    navigator.clipboard.writeText(refLink)
      .then(() => {
        setCopied(true);
        notify.success('Referral link copied!');
        setTimeout(() => setCopied(false), 2000);
      })
      .catch(() => notify.error('Could not copy.'));
  }

  return (
    <div className="ref-card">
      <div className="ref-card-header">
        <div className="ref-card-title">
          <div className="ref-icon">🎁</div>
          <span>Your Referral Link</span>
        </div>
        <div className="ref-count">
          {Number(directReferrals || 0)} direct referrals
        </div>
      </div>
      <div className="ref-link-box">
        <input
          readOnly
          value={refLink}
          onFocus={(e) => e.target.select()}
          aria-label="Referral link"
        />
        <button className="btn btn-primary btn-sm" onClick={copy}>
          {copied ? '✓ Copied' : 'Copy'}
        </button>
      </div>
      <div className="ref-hint">
        Share this link — every direct that purchases a machine unlocks a level for you.
        You earn multi-level rewards on every direct's purchase.
      </div>
    </div>
  );
}
